import { render, staticRenderFns } from "./create-umfrage-modal.vue?vue&type=template&id=74ccbb40&scoped=true"
import script from "./create-umfrage-modal.vue?vue&type=script&lang=js"
export * from "./create-umfrage-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ccbb40",
  null
  
)

export default component.exports